import { useCallback, useMemo } from "react"
import { useDeleteConfirm } from "../../../../hooks/useDeleteConfirm"
import { useProductionKeyValuePairs } from "../../../../hooks/useProductionKeyValuePairs"
import { DimaFeatureShortNameEnum } from "../../../models/Authorization"
import { ProductionKeyValuePairGet } from "../../../models/ProductionKeyValuePair"
import { deleteEntity } from "../../../utils/deleteEntity"
import { DiMaAddButton } from "../../partials/DiMaAddButton"
import { EntityRow, EntityTab } from "../../partials/EntityTab"

export function KeyValuePairs() {
  const { keyValuePairsList, isLoadingKeyValuePairs } = useProductionKeyValuePairs()
  const { requestDelete, DeleteConfirmDialog } = useDeleteConfirm()

  const cols = [
    {
      field: "key",
      headerName: "Key",
      isLink: true,
      linkBasePath: "/production/key-values",
    },
    { field: "value", headerName: "Value" },
  ]

  const rows = keyValuePairsList.map((keyValuePair: ProductionKeyValuePairGet) => ({
    id: keyValuePair.id,
    key: keyValuePair.key,
    value: keyValuePair.value,
  }))

  const toolbar = useMemo(
    () => (
      <DiMaAddButton
        url="/production/key-values/create"
        feature={DimaFeatureShortNameEnum.PR}
      />
    ),
    []
  )

  const handleActionMenuClick = useCallback(
    (item: { title: string }, row: EntityRow) => {
      if (item.title === "Delete") {
        requestDelete(() => deleteEntity(`/production/keyValuePairs/${row.id}`))
      }
    },
    [requestDelete]
  )

  return (
    <>
      {DeleteConfirmDialog}
      <EntityTab
        rows={rows}
        cols={cols}
        isLoading={isLoadingKeyValuePairs}
        toolbar={toolbar}
        actionItems={[{ title: "Delete", iconName: "icon_abb_dias icon-abb_delete" }]}
        onActionMenuClick={handleActionMenuClick}
      />
    </>
  )
}
